"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _getStoragePos = _interopRequireDefault(require("./getStoragePos"));

var _readFromServer = _interopRequireDefault(require("./readFromServer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var sync = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(readURL, localBookmarkData) {
    var serverBookmarkData, updateRequired, mergedBookmarkData, _iterator, _step, item;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (readURL) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            _context.next = 4;
            return (0, _readFromServer.default)(readURL);

          case 4:
            serverBookmarkData = _context.sent;
            updateRequired = false;
            mergedBookmarkData = [];

            if (serverBookmarkData && serverBookmarkData.length > 0) {
              mergedBookmarkData = JSON.parse(JSON.stringify(serverBookmarkData));
            } //! if local bookmark data available -> loop through and compary each item with server data
            //! then merge


            _iterator = _createForOfIteratorHelper(localBookmarkData);
            _context.prev = 9;

            _iterator.s();

          case 11:
            if ((_step = _iterator.n()).done) {
              _context.next = 19;
              break;
            }

            item = _step.value;

            if (!(!item._validationFields || item._validationFields.length === 0)) {
              _context.next = 16;
              break;
            }

            console.warn("no validationFields, sync for this item not possible");
            return _context.abrupt("continue", 17);

          case 16:
            if ((0, _getStoragePos.default)(serverBookmarkData, item, item._validationFields) === -1) {
              mergedBookmarkData.push(item);
              updateRequired = true;
            }

          case 17:
            _context.next = 11;
            break;

          case 19:
            _context.next = 24;
            break;

          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](9);

            _iterator.e(_context.t0);

          case 24:
            _context.prev = 24;

            _iterator.f();

            return _context.finish(24);

          case 27:
            return _context.abrupt("return", {
              mergedBookmarkData: mergedBookmarkData,
              updateRequired: updateRequired
            });

          case 28:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[9, 21, 24, 27]]);
  }));

  return function sync(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var _default = sync;
exports.default = _default;